/**
 * «Запомнить это устройство».
 *
 * ПОЧЕМУ НЕ ПРОСТО ПОЛОЖИТЬ СЕССИЮ В localStorage. Решение 45 запрещает
 * localStorage для bearer-токена, и запрет правильный: украденный XSS'ом
 * рабочий токен действует 12 часов и отозвать его нечем. Поэтому в localStorage
 * лежит ДРУГОЙ секрет — токен устройства (миграция 0058):
 *
 *   * он не открывает данных, а только даёт право получить новую сессию;
 *   * он ОДНОРАЗОВЫЙ: сервер отзывает его при первом же использовании и выдаёт
 *     следующий, поэтому украденная копия работает ровно один раз;
 *   * повторное предъявление уже использованного токена сервер считает кражей и
 *     гасит ВСЕ устройства пользователя;
 *   * его видно в списке «Мои устройства» и можно отозвать.
 *
 * Сессия по-прежнему живёт в sessionStorage и умирает вместе со вкладкой.
 */

const DEVICE_KEY = 'wg.erp.device.v1';

export interface StoredDevice {
  token: string;
  /** Информативно: когда сервер перестанет принимать этот токен. */
  expiresAt: string | null;
}

/** Токен устройства, если он есть и не протух по локальным часам. */
export function readDeviceToken(): string | null {
  try {
    const raw = localStorage.getItem(DEVICE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<StoredDevice>;
    if (typeof parsed.token !== 'string' || parsed.token === '') return null;
    // Протухший по локальным часам не шлём: сервер всё равно откажет, а лишний
    // отказ на старте приложения выглядит как поломка.
    if (parsed.expiresAt && Date.parse(parsed.expiresAt) < Date.now()) {
      forgetDevice();
      return null;
    }
    return parsed.token;
  } catch {
    return null;
  }
}

export function rememberDevice(token: string, expiresAt: string | null): void {
  try {
    localStorage.setItem(DEVICE_KEY, JSON.stringify({ token, expiresAt }));
  } catch {
    // приватный режим без квоты — устройство просто не запомнится
  }
}

export function forgetDevice(): void {
  try {
    localStorage.removeItem(DEVICE_KEY);
  } catch {
    // ignore
  }
}

export function isDeviceRemembered(): boolean {
  return readDeviceToken() !== null;
}

/**
 * Подпись устройства для списка «Мои устройства»: человек должен узнать свой
 * компьютер среди чужих. Точную модель браузер не отдаёт, поэтому берём то, что
 * есть, и не притворяемся, будто знаем больше.
 */
export function describeThisDevice(): string {
  if (typeof navigator === 'undefined') return 'Устройство';
  const ua = navigator.userAgent;
  const os = /Windows/i.test(ua) ? 'Windows'
    : /Macintosh|Mac OS/i.test(ua) ? 'macOS'
      : /Android/i.test(ua) ? 'Android'
        : /iPhone|iPad|iPod/i.test(ua) ? 'iOS'
          : /Linux/i.test(ua) ? 'Linux' : null;
  const browser = /Edg\//i.test(ua) ? 'Edge'
    : /OPR\//i.test(ua) ? 'Opera'
      : /Chrome\//i.test(ua) ? 'Chrome'
        : /Firefox\//i.test(ua) ? 'Firefox'
          : /Safari\//i.test(ua) ? 'Safari' : null;
  return [browser, os].filter(Boolean).join(' · ') || 'Устройство';
}
